import { BetData } from "@fresh8/types/src/betData";
import { bet, preview } from "../prefetch";
import { ref, watchEffect } from "vue";

function awaitPromise<T>(promise: Promise<T>) {
  const result = ref<T | undefined>();
  const loading = ref(true);
  const error = ref(false);

  watchEffect(async () => {
    try {
      result.value = await promise;
      loading.value = false;
    } catch (e) {
      loading.value = false;
      error.value = true;
    }
  });

  return { result, loading, error };
}

export function useGetBetData(operator?: string) {
  const addr = new URL(window.location.href);
  const usePreview = addr.searchParams.get("preview");

  const betDataPromise = awaitPromise<BetData>(
    usePreview ? preview(operator) : bet(operator)
  );

  return betDataPromise;
}
